module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-700.4f79ad80075beafe48e2.eot";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-700.eot
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-700.eot
// module chunks = styles